import React from 'react';

const DebugAuth: React.FC = () => {
  const clientId = import.meta.env.VITE_GOOGLE_CLIENT_ID;
  const redirectUri = import.meta.env.VITE_GOOGLE_REDIRECT_URI;
  const currentUrl = window.location.href;
  const currentOrigin = window.location.origin;

  return (
    <div style={{ 
      minHeight: '100vh', 
      backgroundColor: '#f0f0f0', 
      padding: '2rem',
      fontFamily: 'Arial, sans-serif'
    }}>
      <div style={{ 
        maxWidth: '800px', 
        margin: '0 auto', 
        backgroundColor: 'white', 
        padding: '2rem', 
        borderRadius: '8px', 
        boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
      }}>
        <h1 style={{ 
          fontSize: '2rem', 
          fontWeight: 'bold', 
          color: '#333', 
          marginBottom: '2rem',
          textAlign: 'center'
        }}>
          Debug Google OAuth
        </h1>

        <div style={{ 
          marginBottom: '2rem', 
          padding: '1rem', 
          backgroundColor: '#f8f9fa', 
          borderRadius: '6px' 
        }}>
          <h2 style={{ fontSize: '1.2rem', fontWeight: 'bold', marginBottom: '1rem' }}>
            Environment Variables:
          </h2>
          <p><strong>VITE_GOOGLE_CLIENT_ID:</strong> {clientId || 'NOT SET'}</p>
          <p><strong>VITE_GOOGLE_REDIRECT_URI:</strong> {redirectUri || 'NOT SET'}</p>
        </div>

        <div style={{ 
          marginBottom: '2rem', 
          padding: '1rem', 
          backgroundColor: '#f8f9fa', 
          borderRadius: '6px' 
        }}>
          <h2 style={{ fontSize: '1.2rem', fontWeight: 'bold', marginBottom: '1rem' }}>
            Current URL Info:
          </h2>
          <p><strong>Current URL:</strong> {currentUrl}</p>
          <p><strong>Current Origin:</strong> {currentOrigin}</p>
          <p><strong>Protocol:</strong> {window.location.protocol}</p>
          <p><strong>Host:</strong> {window.location.host}</p>
          <p><strong>Port:</strong> {window.location.port || 'default'}</p>
        </div>

        <div style={{ 
          marginBottom: '2rem', 
          padding: '1rem', 
          backgroundColor: '#f8f9fa', 
          borderRadius: '6px' 
        }}>
          <h2 style={{ fontSize: '1.2rem', fontWeight: 'bold', marginBottom: '1rem' }}>
            Google Cloud Console Configuration:
          </h2>
          <p><strong>Authorized JavaScript origins should include:</strong></p>
          <ul style={{ marginLeft: '1rem' }}>
            <li>{currentOrigin}</li>
            <li>http://localhost:3000</li>
            <li>http://localhost:3001</li>
            <li>http://localhost:3002</li>
            <li>http://127.0.0.1:3000</li>
            <li>http://127.0.0.1:3001</li>
            <li>http://127.0.0.1:3002</li>
          </ul>
        </div>

        <div style={{ 
          marginBottom: '2rem', 
          padding: '1rem', 
          backgroundColor: '#fff3cd', 
          borderRadius: '6px',
          border: '1px solid #ffeaa7'
        }}>
          <h2 style={{ fontSize: '1.2rem', fontWeight: 'bold', marginBottom: '1rem', color: '#856404' }}>
            Required .env file:
          </h2>
          <pre style={{ 
            backgroundColor: '#f8f9fa', 
            padding: '1rem', 
            borderRadius: '4px',
            fontSize: '0.9rem',
            overflow: 'auto'
          }}>
{`VITE_GOOGLE_CLIENT_ID=27271216838-glfjmspkiq31v4u4h6dhcvdeq4k1qkj5.apps.googleusercontent.com
VITE_GOOGLE_REDIRECT_URI=http://localhost:3000/auth/google/callback`}
          </pre>
        </div>

        <div style={{ 
          marginBottom: '2rem', 
          padding: '1rem', 
          backgroundColor: '#d1ecf1', 
          borderRadius: '6px',
          border: '1px solid #bee5eb'
        }}>
          <h2 style={{ fontSize: '1.2rem', fontWeight: 'bold', marginBottom: '1rem', color: '#0c5460' }}>
            Steps to fix:
          </h2>
          <ol style={{ marginLeft: '1rem' }}>
            <li>Create <code>.env</code> file in project root</li>
            <li>Add the environment variables above</li>
            <li>Update Google Cloud Console with all origins listed above</li>
            <li>Restart the development server</li>
            <li>Clear browser cache and try again</li>
          </ol>
        </div>

        <div style={{ textAlign: 'center' }}>
          <a 
            href="/" 
            style={{ 
              color: '#007bff', 
              textDecoration: 'none',
              marginRight: '1rem'
            }}
          >
            ← Về trang chủ
          </a>
          <a 
            href="/auth-test" 
            style={{ 
              color: '#007bff', 
              textDecoration: 'none'
            }}
          >
            Test Auth
          </a>
        </div>
      </div>
    </div>
  );
};

export default DebugAuth;
